export default "__VITE_ASSET__CKsicX2$__"